import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as directives from '../../../directives'

/**
 * Component for displaying icon based on the {@link ents.core.display.Style | Style } input
 *
 * **Inputs**
 * - {@link ents.core.display.Style |Style}!
 *
 * @example
 * ```html
 * <atn-ds-icon style="Warning" />
 * ```
 */
@ngCore.Component({
  imports: [directives.tooltip.Directive],
  selector: 'atn-ds-notice-icon',
  standalone: true,
  styleUrls: ['./icon.component.scss'],
  templateUrl: './icon.component.html',
})
export class AtnDsNoticeIconComponent {
  /**
   * Style input indicating which icon should be shown.
   *
   * @see {@link ents.core.display.Style}
   */
  public readonly styleSg = ngCore.input<ents.core.display.Style | undefined>(
    undefined,
    {
      alias: 'style',
    },
  )

  /**
   * Text to be displayed in tooltip if it is passed, undefined means that the
   * tooltip won't be shown
   */
  public readonly descriptionSg = ngCore.input<string | undefined>(undefined, {
    alias: 'description',
  })

  /**
   * Style enum exposed to HTML
   *
   * @see {@link ents.core.display.Style}
   */
  public readonly StyleEnum = ents.core.display.Style
}
